import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
export var ApiUrl = /*#__PURE__*/function () {
  function ApiUrl() {
    _classCallCheck(this, ApiUrl);
  }
  _createClass(ApiUrl, null, [{
    key: "webapiurl",
    value:
    /**
     * ApiUrl() gives the endpoint for the web api
     */
    function webapiurl() {
      switch (window.location.host) {
        case 'sorekenmodule.wser.wur.nl':
          return 'https://sorekenmodule.wser.wur.nl/WebApi';
        case 'acc.sorekenmodule.wser.wur.nl':
          return 'https://acc.sorekenmodule.wser.wur.nl/WebApi';
        case 'tst.sorekenmodule.wser.wur.nl':
          return 'https://tst.sorekenmodule.wser.wur.nl/WebApi';
        default:
          return 'https://localhost:44381';
      }
    }
  }]);
  return ApiUrl;
}();